module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Light.69a7091d.otf";